module.exports = __webpack_public_path__ + "media/payment_options/amex-0d505a3d.png";